import type { LocalizationMap } from './Localization/Localization';
// ------------------------------------------------------------------------------------------------ +++ Localization
export const SearchBarLocalizationTextMapKey: string = "Primitive_SearchBar";
// ------------------------------------------------------------------------------------------------
export const enum SearchBarUILabelKey {
    Options = "tooltip-options",
    UseRegEx = "switch-use-regex",
    MatchCase = "switch-match-case",
    MatchWholeWord = "switch-match-whole-word",
    HintText = 'hint-text'
};
// ------------------------------------------------------------------------------------------------
export function SearchBarGetLocalizationDictionary(): LocalizationMap {
    return {
        [SearchBarUILabelKey.Options]: "Options",
        [SearchBarUILabelKey.UseRegEx]: "Use regular expression",
        [SearchBarUILabelKey.MatchCase]: "Match case",
        [SearchBarUILabelKey.MatchWholeWord]: "Match whole word",
        [SearchBarUILabelKey.HintText]: "Search",
    };
}
// ------------------------------------------------------------------------------------------------